'use client';

import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';
import { motion } from 'framer-motion';

export function ThemeToggle({
  collapsed,
  showContent,
}: {
  collapsed: boolean;
  showContent: boolean;
}) {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null; // ⛔️ Previene renderización hasta que esté montado

  return (
    <button
      className={`flex text-xs items-center px-3 py-2 hover:text-(--exacto-health-color-primary) dark:hover:text-violet-400 transition w-full ${collapsed ? 'justify-center' : 'gap-3'}`}
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
    >
      {theme === 'dark' ? (
        <Sun className="h-5 w-5" />
      ) : (
        <Moon className="h-5 w-5" />
      )}
      {/* <span className="sr-only">Toggle theme</span> */}
      {showContent && !collapsed && (
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="whitespace-nowrap"
        >
          {theme === 'dark' ? 'Tema claro' : 'Tema oscuro'}
        </motion.span>
      )}
    </button>
  );
}
